var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58232 3.44775C7.04311 2.62573 5.40647 3.00984 4.32446 3.99685C3.24905 4.97784 2.6849 6.57584 3.18303 8.23852L4.01035 11H8.33728C8.88956 11 9.33728 11.4477 9.33728 12C9.33728 12.5523 8.88956 13 8.33728 13H4.01887L3.18922 15.7587C2.68947 17.4205 3.25165 19.0188 4.32559 20.0011C5.4061 20.9893 7.04187 21.3758 8.582 20.5565L17.901 15.5985C20.6979 14.1105 20.7006 9.91957 17.9062 8.42723L8.58232 3.44775Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendActive);
export default __webpack_public_path__ + "static/media/send-active.47698595eb3d3e544a4812b2c4f1cad5.svg";
export { ForwardRef as ReactComponent };